import React from "react";
import ChartBase from "./ChartBase";

const Line = ({
  series = [],
  categories = [],
  options = {},
  height = "100%",
  width = "100%",
}) => {
  const baseOptions = {
    chart: {},
    stroke: { curve: "smooth", width: 2 },
    dataLabels: { enabled: false },
    xaxis: { categories },
    markers: { size: 0 },
  };

  const mergedOptions = {
    ...baseOptions,
    ...options,
    xaxis: { ...baseOptions.xaxis, ...(options.xaxis || {}), categories },
  };

  return (
    <ChartBase
      type="line"
      series={series}
      categories={categories}
      options={mergedOptions}
      height={height}
      width={width}
    />
  );
};

export default Line;
